import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../lib/axios.js';

export async function registerPushToken(token) {
  const response = await axiosInstance.post(
    '/push/token',
    { token },
    { withCredentials: true }
  );
  return response.data;
}

export async function unregisterPushToken(token) {
  const response = await axiosInstance.delete(
    '/push/token',
    { data: { token }, withCredentials: true }
  );
  return response.data;
}

export const useRegisterPushToken = () => {
  return useMutation({
    mutationKey: ['register-push-token'],
    mutationFn: registerPushToken,
  });
};

export const useUnregisterPushToken = () => {
  return useMutation({
    mutationKey: ['unregister-push-token'],
    mutationFn: unregisterPushToken,
  });
};
